import {  Component, Vue } from "vue-property-decorator"
import { financeMarketCostStatisticalData, financeMarketCostStatisticalDataExport } from '@/api/financial-center'
import { delNullProperty } from '@/utils/index'
import {UserModule} from "@/store/modules/user";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import commonData from "@/utils/commonData";

const projectTypeFilter = commonData.projectTypeArray
@Component({
  components:{
    MoreUsersFilter
  }
})
export default class OrderStatisticsData extends Vue {

  page = 1
  limit = 20
  total = 0
  dissertationType = ''
  souCourseName = ''
  souCourseSchoolBegin = []
  tableData = []
  tableLoading = false
  popover1 = false
  popover2 = false
  popover3 = false
  exportButtonDisabled = false
  exportHeaderDialogVisible = false
  tableHeader: any = [
    { filds: 'customerName', cnFilds: '客户名称', isShow: true, id: 1 },
    { filds: 'souCourseName', cnFilds: '项目名称', isShow: true, id: 2 },
    { filds: 'souCourseType', cnFilds: '项目类型', isShow: true, id: 3 },
    { filds: 'marketCooperationName', cnFilds: '合作伙伴名称', isShow: true, id: 4 },
    { filds: 'marketCooperationTypes', cnFilds: '合作伙伴类型', isShow: true, id: 5 },
    { filds: 'types', cnFilds: '费用类型', isShow: true, id: 6 },
    { filds: 'price', cnFilds: '市场费用金额', isShow: true, id: 7 },
    { filds: 'score', cnFilds: '市场费用积分', isShow: true, id: 8 },
    { filds: 'code', cnFilds: '市场费用编号', isShow: true, id: 9 },
    { filds: 'status', cnFilds: '状态', isShow: true, id: 10 },
    { filds: 'createdAt', cnFilds: '创建时间', isShow: true, id: 11 },
    { filds: 'financeMarketCostDetailTime', cnFilds: '审批通过时间', isShow: true, id: 12 },
    { filds: 'payStatus', cnFilds: '打款状态', isShow: true, id: 13 },
    { filds: 'financeOrderCode', cnFilds: '订单编号', isShow: true, id: 14 },
    { filds: 'commissionType', cnFilds: '佣金类型', isShow: true, id: 15 },
    { filds: 'ratio', cnFilds: '返点比例', isShow: true, id: 16 },
    { filds: 'financeOrderPrice', cnFilds: '订单金额', isShow: true, id: 17 },
    { filds: 'souCoursePrice', cnFilds: '项目终端售价', isShow: true, id: 18 },
    { filds: 'discountPrice', cnFilds: '优惠金额', isShow: true, id: 19 },
    { filds: 'financeRepeatOrderFlag', cnFilds: '撞单', isShow: true, id: 20 },
    { filds: 'marketClueDirectorUserRealName', cnFilds: '市场负责人', isShow: true, id: 21 },
    { filds: 'financeOrderCreatedUserRealName', cnFilds: '订单创建人', isShow: true, id: 22 },
    { filds: 'financeOrderCreatedUserDepartmentName', cnFilds: '订单创建人所属部门', isShow: true, id: 23 },
    { filds: 'financeOrderCooperationUserRealName', cnFilds: '合作成单同事', isShow: true, id: 24 },
    { filds: 'financeOrderAchievementRatio', cnFilds: '业绩比例分配', isShow: true, id: 25 },
    { filds: 'adviser', cnFilds: '送生顾问', isShow: true, id: 26 },
    { filds: 'customerDirectorUserRealName', cnFilds: '客户负责人', isShow: true, id: 27 },
    { filds: 'marketChannelType', cnFilds: '渠道类型', isShow: true, id: 28 },
    { filds: 'marketClueCreatedUserRealName', cnFilds: '线索创建人', isShow: true, id: 29 },
    { filds: 'reason', cnFilds: '市场费用申请原因', isShow: true, id: 30 },
  ]
  customerName = ''
  status = ''
  marketCooperationName = ''
  types = ''
  timer = null
  // isReadonly = false
  payStatus = '' // 打款状态
  projectTypeFilter = projectTypeFilter //项目类型
  souCourseTypeIdList = []
  createdUserId = ''
  financeOrderCreatedUserIdList = []
  reason =  '' //申请原因
  financeOrderCode = '' // 订单编号

  created() {
    this.getTableData()
  }

  pageChange(page: number) {
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = page
      this.getTableData()
    }, 1000)
  }
  // computed

  async getTableData() {
    this.popover1 = false
    this.popover2 = false
    this.popover3 = false
    this.tableLoading = true

    const { allNum, financeMarketCostList } = await financeMarketCostStatisticalData(delNullProperty({
      limit: this.limit,
      page: this.page,
      customerName : this.customerName,
      status: this.status,
      marketCooperationName : this.marketCooperationName,
      types : this.types,
      payStatus : this.payStatus,
      financeOrderCreatedUserIdList : this.financeOrderCreatedUserIdList,
      souCourseTypeIdList : this.souCourseTypeIdList,
      reason : this.reason,
      financeOrderCode : this.financeOrderCode,
    })) as unknown as { allNum: number; financeMarketCostList: any[] }
    this.tableData = financeMarketCostList
    this.total = allNum
    this.tableLoading = false
    // this.isReadonly = false
  }

  async exportExcel(keys: string = '') {
    this.exportButtonDisabled = true
    await financeMarketCostStatisticalDataExport(delNullProperty(
        {
          customerName: this.customerName,
          status: this.status,
          marketCooperationName: this.marketCooperationName,
          types: this.types,
          payStatus: this.payStatus,
          financeOrderCreatedUserIdList: this.financeOrderCreatedUserIdList,
          souCourseTypeIdList: this.souCourseTypeIdList,
          reason: this.reason,
          financeOrderCode: this.financeOrderCode,
          keys,
        })
    )
    this.$message.success('数据已转入后台导出, 请前往下载列表查看')
    this.exportButtonDisabled = false
  }

  // pageChange(page: number) {
  //   this.page = page
  //   this.getTableData()
  // }

  pageSizeChange(limit: number) {
    this.limit = limit
    this.getTableData()
  }

  changeFinanceOrderCreatedUserIdList(e) {
    this.financeOrderCreatedUserIdList = e.id
    this.page = 1
    this.getTableData()
  }

}
